import classNames from 'classnames'

const colors = {
	free: { text: 'text-white', icon: '/liveGameIcons/unique/vikings/northern_migration.png' },
	warning: {
		text: 'text-yellow-500',
		icon: '/liveGameIcons/unique/vikings/northern_migration_med.png',
	},
	full: {
		text: 'text-red-500',
		icon: '/liveGameIcons/unique/vikings/northern_migration_full.png',
	},
	overpop: {
		text: 'text-red-700 font-bold liveGameOverlay__population__overpop',
		icon: '/liveGameIcons/unique/vikings/northern_migration_full.png',
	},
}

export function LiveGamePopulationVikings({ currentPopulation, maxPopulation, leftSide }) {
	let popState = 'free'
	if (currentPopulation === 200) popState = 'free'
	else if (currentPopulation > maxPopulation) popState = 'overpop'
	else if (currentPopulation === maxPopulation) popState = 'full'
	else if (currentPopulation / maxPopulation > 0.9) popState = 'warning'

	return (
		<div className={classNames('flex ', !leftSide ? 'flex-row justify-end' : 'flex-row-reverse justify-end')}>
			<div className={classNames('flex flex-row', !leftSide ? 'mr-[1px]' : 'ml-[10px]')}>
				<h1 className={classNames(colors[popState].text, 'text-lg')}>{currentPopulation}</h1>
				<h1 className="text-[#b1b1b1] text-lg">/{maxPopulation}</h1>
			</div>
			<img src={colors[popState].icon} className={classNames('w-6 h-6 -mt-[0px]', !leftSide ? 'mx-[4px]' : '-mx-[2px]')} alt="" />
		</div>
	)
}
